import { useEffect } from 'react';

const replaceBrowserLocation = (to) => window.location.replace(to);

const ExternalRedirect = ({ to, replace = replaceBrowserLocation }) => {
  useEffect(() => {
    replace(to);
  }, [replace, to]);

  return null;
};

export default ExternalRedirect;
